import { Cross1Icon } from '@radix-ui/react-icons'
import React, { ReactNode } from 'react'
import styled from 'styled-components'

export interface MessageBannerProps {
  showBanner: boolean
  contents: ReactNode
  hideBanner: () => void
  absolutePositionTop?: boolean
  color?: string
}

const BannerArea = styled.div<{ $absolutePositionTop?: boolean }>`
  ${(props) =>
    props.$absolutePositionTop
      ? 'position: fixed; right: 0; left: 0; top: 0; z-index: 30;'
      : ''}
`

const BannerMessage = styled.div<{
  $color?: string
}>`
  background-color: ${(props) =>
    props.$color ? props.$color : props.theme.colors.crimson['600']};
  border-radius: 0.25rem;
  width: 100%;
  height: 4rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  gap: 0.75rem;
  font-family: ${(props) => props.theme.fontFamily.manrope};
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 150%;

  #banner-error-message {
    color: white;
  }

  #banner-error-details {
    color: white;
  }

  #banner-error-link {
    color: white;
  }

  & > div {
    display: flex;
    gap: 0.75rem;
  }

  & > svg {
    cursor: pointer;
  }
`

export const MessageBanner: React.FC<MessageBannerProps> = (props) => {
  return (
    <>
      {props.showBanner ? (
        <BannerArea $absolutePositionTop={props.absolutePositionTop}>
          <BannerMessage $color={props.color}>
            <div>{props.contents}</div>
            <Cross1Icon
              role='button'
              tabIndex={0}
              aria-label='Dismiss message'
              onClick={() => props.hideBanner()}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  props.hideBanner()
                }
              }}
            />
          </BannerMessage>
        </BannerArea>
      ) : null}
    </>
  )
}
